// extracted by mini-css-extract-plugin
module.exports = {"about":"e67d88","aboutInner":"cf10f4"};